export default function hasStock(product) {
  if (product.hasUnlimitedStock || product.stock > 0) {
    return true;
  }

  return false;
}
